export { default as PageShell, type PageShellProps } from './PageShell';
